<template>
  <div>
		<Layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="6" class="text-end pt-4">
              <h1>{{ $t('meter.overview_electricity_month') }}</h1>
            </v-col>
            <v-col cols="6">
              <div style="max-width: 200px;">
                <SelectMonthYear
                  :isDisabled="isLoading"
                  @onSelect="onSelectMonthYear"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <template>
          <div class="grid grid-cols-5 gap-2 py-3">
            <div>
              <router-link class="router-class" to="project">
                {{ $t('meter.overview_project') }}
              </router-link>
            </div>
            <div>
              <router-link class="router-class" to="meter">
                {{ $t('meter.overview_meter') }}
              </router-link>
            </div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div v-if="!isLoading">
            <ProjectReportDigitalMerterOverallByProject
              v-if="$route.params.type == 'project'"
              :selectedMonthYear="selectedMonthYear"
            />
            <ProjectReportDigitalMerterOverallByMeter
              v-if="$route.params.type == 'meter'"
              :selectedMonthYear="selectedMonthYear"
            />
          </div>
        </template>

        <v-card class="d-flex justify-center py-10" v-if="isLoading">
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </v-card>
			</template>
		</Layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
	</div>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/components/Layout.vue";
import SelectMonthYear from "@/components/SelectMonthYear.component.vue";
import ProjectReportDigitalMerterOverallByProject from "@/components/ProjectReportDigitalMerterOverallByProject.component.vue";
import ProjectReportDigitalMerterOverallByMeter from "@/components/ProjectReportDigitalMerterOverallByMeter.componenet.vue";
export default {
	components: {
		Layout,
    SelectMonthYear,
    ProjectReportDigitalMerterOverallByProject,
    ProjectReportDigitalMerterOverallByMeter
	},
  data() {
    return {
			projectId: this.$route.params.projectId,
			isLoading: true,
			isError: false,
      selectedMonthYear: null,
      markets: null,
      project: null
    }
  },
  computed: {
    ...mapState({
      sessionAdmins: (state) => state.admin.sessionAdmins,
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
  },
	methods: {
		async initData(){
			this.isLoading = true
			try {
        if(this.admins){
          this.project = this.admins[0].project
          this.markets = this.admins.map(d => d.market)
        }
        await this.$store.dispatch("meter/getMeterDigitalByMarkets", this.markets.map(d => d.objectId))
        await this.$store.dispatch("digitalMeterReport/getMonthReports", {
          cust_id_list: this.project.digitalMeterData.cust_id_list,
          month: this.selectedMonthYear.month,
          year: this.selectedMonthYear.year
        })
				this.isLoading = false
			} catch(error) {
				this.isLoading = false
				this.isError = true
			}
		},
    async onSelectMonthYear(data) {
      this.selectedMonthYear = data;
      await this.initData();
    },
	}
}
</script>
<style scoped>
.router-link-exact-active {
  @apply text-screamin-green-700 !important;
}
.router-class {
  @apply bg-white block w-full p-3 text-center text-black transition-all  rounded hover:text-screamin-green-700 hover:scale-110;
}
</style>